import { render, staticRenderFns } from "./ProInfo.vue?vue&type=template&id=1d56cc22&"
import script from "./ProInfo.vue?vue&type=script&lang=js&"
export * from "./ProInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports